<template>
  <div class="row">
    <div
    class="col-xs-12"

      style="
        width: 100%;
        background: #bdd6ec;
        border: 1px solid #337ab7;
        border-radius: 5px;
        text-align: start;
        margin-bottom: 10px;
        margin-top: 5px;
      ">
      {{title}}
    </div>
    <textarea v-if="isEditing == true"
    class="form-control txt_edit"
    name="" id=""
    cols="30" rows="10"
    v-model="textContent"></textarea>
    <div v-else class="txt_edit"
    style="width: 100%;   text-align: start; min-height: 222px;border: 1px solid #ccc;border-radius: 5px;"
    v-html="textContent.replace(/\n/g,'<br>')"></div>
    <button
      v-if="showEdit"
      v-show="isEditing == false"
      @click="onEdit"
      class="btn btn-primary btn_edit">編集</button>
    <div v-else  style="margin-bottom: 20px;"></div>


    <button
      v-show="isEditing == true"
      @click="onSave"
      class="btn btn-primary btn_edit"
      style="background: #92D050;border-color:#92D050;"
      >登録</button>
    <button
      v-show="isEditing == true"
      @click="onCancel"
      class="btn btn-primary btn_edit"
      style="background: #A6A6A6;border-color:#A6A6A6;"
      >キャンセル</button>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import MenuBtn from "../components/menu-btn";
import { utils } from "@/libs/utils";
// import mixinMenuCommon from "@/mixins/mixin_menu_common";
import mixinPageCommon from "@/mixins/mixin_page_common";
// import noticeModal from "../components/modals/notice-modal";

import debug from "debug";
var debug_menu = debug("esma:info_box");

Vue.component("menu-btn", MenuBtn);

import { bus } from "@/libs/bus";

export default {
  mixins: [
    mixinPageCommon],
  components: {
    // "notice-modal": noticeModal,
  },
  //  name: 'Name here',
  data() {
    return {
      text_content:"",
      local_data:false,
      is_editing :false,
      show_edit:false
    };
  },

  computed: {
    showEdit:{
      get(){
        return this.show_edit;
      },
      set(v){
        this.show_edit = v;
      }
    },
    isEditing:{
      get(){
        return this.is_editing;
      },
      set(v){
        this.is_editing = v;
      }
    },
    textContent:{
      get(){
        return this.text_content;
      },
      set(v){
        this.text_content = v;
      }
    },
  },
  methods: {
    onSave(){
      var seq_id = this.local_data.seq_id
      this.$ajax.post_cached_queued("/key_text/set/" + seq_id  , {changes:{k_text :this.textContent }}, (err, result) => {
        if(err){
          this.$notify({
            title: 'Failed to load data',
            text: err,
            type: 'error',
            duration: 10000
          });
          return;
        }else{
          this.isEditing = false;
        }
      })
    },
    onCancel(){
      this.isEditing = false;
      this.textContent = this.local_data.k_text;
    },
    onEdit(){
      this.isEditing = true;
    },
    loadData(){
      this.textContent = "Loading...."
      this.$ajax.post_cached_queued("/key_text/get_by_key/" + this.box_id  , {}, (err, result) => {
        if(err){
          this.$notify({
            title: 'Failed to load data',
            text: err,
            type: 'error',
            duration: 10000
          });
          return;
        }
        this.local_data = result;
        this.textContent = result.k_text || "Data not found";
      })
    }
  },
  mounted() {
    this.textContent = this.box_id;
    this.loadData()
    this.showEdit = this.isMultiCompanyAdmin == true;

  },
  props: {
    title: { type: String, default: "--" },
    "box_id": { type: String, default: "x" }
  },
};
</script>
<style scoped>
.btn_edit {
  margin: 10px 0px 20px 10px;
  float: right;
  min-width:80px;
}
.txt_edit{
  background-color: white!important;
  padding: 10px 15px;
}
</style>



// WEBPACK FOOTER //
// info-box.vue?db5a75fc